import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  LicensedComponentId,
  LicensedProductComponentDto,
} from 'src/app/models/license.model';

export type LicensedComponentCardItem = Omit<
  LicensedProductComponentDto,
  'id'
> & { id: LicensedComponentId };

@Component({
  selector: 'app-license-component-card',
  templateUrl: './license-component-card.component.html',
  styleUrls: ['./license-component-card.component.scss'],
  standalone: false,
})
export class LicenseComponentCardComponent {
  @Input() component!: LicensedComponentCardItem;
  @Input() displayName!: string;
  @Input() selected = false;

  @Output() toggle = new EventEmitter<LicensedComponentId>();

  get actionLabel(): string {
    return this.selected ? 'Remove component' : 'Add component';
  }

  get actionIcon(): string {
    return this.selected ? 'remove_circle_outline' : 'add_circle_outline';
  }

  onToggle(): void {
    this.toggle.emit(this.component.id);
  }
}
